import { useQuery } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';

export const FindModelsQueryKey = 'find-models';

export const useFindModelsQuery = () =>
  useQuery(FindModelsQueryKey, async () => {
    const { data } = await apiCpService.getModelsCpClientModelsGet();

    return Object.entries(data);
  });
